import { Radio as MRadio, RadioProps } from '@mui/material'

export const Radio: React.FC<RadioProps> = (props) => {
  return <MRadio {...props} />
}
